module.exports = __webpack_public_path__ + "img/r112.a8eee44d.png";